import React, { FC } from "react";
import { useParams } from "react-router-dom";

import ServiceDetail from "./ServiceDetail";

const ServicePage: FC = () => {
  const { serviceId } = useParams();

  return <ServiceDetail serviceId={serviceId} />;
};

export default ServicePage;
